import {
  appendRequiredAsterisk,
  getInfoBox,
  getLabel,
} from "Components/abstract/sc-e-form-field/sc-e-form-field.template";
import { html } from "lit-html";
import { ifDefined } from "lit/directives/if-defined.js";

import { ScTextarea } from "./sc-e-textarea";

export interface TextareaTemplateArgs {
  component: ScTextarea;
}

const getCharCounter = (args: TextareaTemplateArgs) => {
  if (typeof args.component.maxlength !== "number") return;
  return html`
    <span class="sc-e-textarea__char-counter" aria-hidden="true"
      >${args.component.submitValue.length}/${args.component.maxlength.toString()}
    </span>
  `;
};

const getTextarea = (args: TextareaTemplateArgs) => {
  return html`
    <textarea
      class="sc-e-form-field__input sc-js-form-field__input sc-e-textarea__textarea"
      id="${args.component.id}"
      name="${args.component.name}"
      placeholder="${args.component.isRequired
        ? appendRequiredAsterisk(args.component.placeholder, args.component.isRequired)
        : args.component.placeholder}"
      aria-describedby="info-box-${args.component.id}"
      ?required=${args.component.isRequired}
      ?readonly=${args.component.isReadonly}
      ?disabled=${args.component.isDisabled}
      rows=${ifDefined(args.component.rowsCount)}
      tabindex=${ifDefined(args.component.isReadonly ? "-1" : undefined)}
      minlength=${args.component.minlength || "auto"}
      maxlength=${args.component.maxlength || "auto"}
    ></textarea>
  `;
};

// prettier-ignore
export const textareaTemplate = (args: TextareaTemplateArgs) => {
  return html`
    <div class="sc-e-form-field__box sc-e-textarea__box">
      ${getLabel({ 
        for: args.component.id, 
        label: args.component.label, 
        isRequired: args.component.isRequired 
      })}
      ${getTextarea(args)}
      ${getCharCounter(args)}
    </div>
    ${getInfoBox<string, ScTextarea>({
      formField: args.component
    })}
  `;
};
